import RN from "../../assets/react-native-img.png";
import TS from "../../assets/typescript-img.png";
import KT from "../../assets/kotlin-img.png";
import IG from "../../assets/instagram.svg";
import IN from "../../assets/LinkedIn.svg";
import GT from "../../assets/github.svg";

export interface Content {
	Title?: string;
	Text?: string;
	Sample?: string; // code sample if any
}
export interface IBlog {
	ID?: number;
	Title?: string;
	Content: Content[];
	Author?: string;
	SocialLink?: string;
	SourceCodeLinkName?: string;
	SourceCodeLink?: string;
	Resource?: Resource[];
	SocialNetwork?: SocialNetwork[];
	Image?: string;
}

export interface SocialNetwork {
	Image?: string
	Link?: string;
}
export interface Resource {
	ResourceLinkName?: string;
	ResourceLink?: string;
}

interface Blogs {
	data: IBlog[];
}

export const reynaldoSocialNetwork: SocialNetwork[] = [
	{
		Image: IN,
		Link: "https://www.linkedin.com/in/reynaldomejia/"
	},
	{
		Image: GT,
		Link: "https://github.com/redmejia"
	},
	{
		Image: IG,
		Link: "https://www.instagram.com/reynaldomejiamunoz/"
	}
]

export const joseSocialNetwork: SocialNetwork[] = [
	{
		Image: IN,
		Link: "https://www.linkedin.com/in/jose-h-mejia-munoz/",
	},
	{
		Image: GT,
		Link: "https://github.com/jmejiamu"
	},
	{
		Image: IG,
		Link: "https://www.instagram.com/josehmejia_jr/"
	}
]

export const DATA: Blogs = {
	data: [
		{
			ID: 1,
			Title: "Typescript Basics",
			Image: TS,
			Author: "Reynaldo Mejia",
			SocialLink: reynaldoSocialNetwork[0].Link,
			SourceCodeLink: "https://github.com/redmejia/learning-typescript",
			SourceCodeLinkName: "Learning Typescript Basics",
			Content: [
				{
					Title: "What is TypeScript",
					Text: `
                        Typescript is a programming language that is a superset of JavaScript. In other words, any JavaScript code is valid Typescript code. However, TypeScript adds statics typing to the language, this means that you can specify types of variables, parameters and return values in your code.
                        in JavaScript, variables can hold values of any type, and the type can change during run time.Typescript introduce static typing, allowing to declare the type of variables, making it easier to catch and prevent certain types of errors during development. This can lead to more robust and maintainable code.
                    `,
				},
				{
					Title: "Basics Types",
					Text: `When you declare a variable, you can also specify its type. This helps TypeScript catch and prevent type mismatches during development.`,
				},
				{
					Text: "string: Represents sequences of text characters.",
					Sample: `
    let name: string = "Alice";
    name = 34 // error variable was defined to store string type
    const midName: string = 'R';
    const data = \`\

        <header>
        <h1>TypeScript</h1>
        </header>
        <main>
          <h1>Learn TypeScript Basics</h1>
          <h2>Welcome, Reynaldo!</h2>
          <p> Hello, Mundo 🌎 </p>
        </main>
    \`\
    `,
				},
				{
					Text: "number: Represents floating-point and integer numbers.",
					Sample: `
    let price: number = 53.89;
    let age: number = 54;
    // if you try to change the type it will give an error
    age = "78"; // ERROR
                    `,
				},
				{
					Text: "boolean: Represents true or false values.",
					Sample: `
    let isActive: boolean = false;
    let isStudent: boolean = true;
                    `,
				},
				{
					Text: "tuple: Represents an ordered collection of values of specific types and fixed length.",
					Sample: `
    let person: [string, number] = ["Alice", 32];
                    `,
				},
				{
					Text: "enum: Represents a set of named constants.",
					Sample: `
    enum Color {
        RED,
        BLUE,
        GREEN,
    }
                    `,
				},
				{
					Text: "object: Represents unordered collections of key-value pairs.",
					Sample: `
    {name: "Lina", age: 21, isStudent?: true};
                    `,
				},
				{
					Text: "interface: Defines the shape of an object, specifying required and optional properties with their types.",
					Sample: `
    interface Person {
        name: string;
        age: number;
        isStudent?: boolean
    }
    let reynaldo: Person = {
        name: "Reynaldo",
        age: 23,
    }`,
				},
			],
		},
		{
			ID: 2,
			Title: "React Native: Creating a Customized Bottom Navigation ",
			Author: "Jose H  Mejia Munoz",
			Image: RN,
			SocialLink: "https://beacons.ai/jmejiamu",
			SocialNetwork: joseSocialNetwork,
			Content: [
				{
					Title: "Navigation",
					Text: `First, let's understand understand how the bottom navigation works. 
          The bottom navigation behaves like a stack of screens, where each tab is an individual screen. 
          When a tab is clicked, the corresponding screen is pushed to the top of the stack. 
          This allows the user to navigate between screens by switching tabs. 
          Imagine a stack of cards where each card represents a screen. 
          When a tab is clicked, the corresponding card is brought to the top of the stack.`,
				},
				{
					Title: "Installing the bottom navigation",
					Text: `To create a custom bottom navigation, we need to use the Navigation component from the React Navigation library. 
          The Navigation component provides a way to create a stack of screens that can be navigated using tabs. 
          We can customize the appearance of the bottom navigation by specifying the tab bar options, such as the tab bar icon and label.`,
					Sample: `
            yarn add @react-navigation/stack
            npx expo install react-native-gesture-handler
            yarn add @react-navigation/native
            yarn add react-native-safe-area-context
            yarn add @react-navigation/bottom-tabs`,
				},
				{
					Title: "Creating the bottom navigation",
					Text: `To create a custom bottom navigation, we need to define the screens that will be displayed in each tab. 
            We can create a separate component for each screen and import them into the Navigation component. 
            To create the bottom navigation, let's create the bottom navigation component. We are going to named it BottomNav. 
            Here we are going to have the main navigation with the screens we want to display. 
            In the tabBar we are going to call the CustomBottomNav component and pass all the props.`,
					Sample: `
            import { createBottomTabNavigator } from "@react-navigation/bottom-tabs"; 
            import { Home, Profile, Setting } from "../../screens";
            import { CustomBottomNav } from "../../component";

            const Tab = createBottomTabNavigator();
            export const BottomNav = () => {
            return (
            <Tab.Navigator tabBar=((props) = <CustomBottomNav {..props} />}>
                ‹Tab.Screen name="Home" component={Home} />
                ‹Tab.Screen name="Settings" component={Setting} />
                ‹Tab.Screen name="Profile" component={Profile} />
            </Tab. Navigator>
            );
        ｝；`,
				},
				{
					Title: "Styling the bottom navigation",
					Text: `To style the bottom navigation, we can use the StyleSheet component from React Native. 
          Also,we are going to create a new component called CustomBottomNav which had been called where we defined the bottom navigation .
        Now we can define the styles for the navigation bar.
            In the next step we are going to create a component called CustomMenuIcon to style the icons`,
					Sample: `
            import { StyleSheet, View } from "react-native";
            import React from "react";
            import { BottomTabBarProps } from "@react-navigation/bottom-tabs";
            import { CustomMenuIcon } from "../CustomMenuIcon";

            export const CustomBottomNav = (props: BottomTabBarProps) => {
              const { state, descriptors, navigation } = props;
              return (
                <View style={styles.container}>
                  {state?.routes?.map((route, index: number) => {
                    const { options } = descriptors[route.key];
                    // the label is taken from the tabBarLabel
                    const label =
                      options.tabBarLabel !== undefined
                        ? options.tabBarLabel
                        : options.title !== undefined
                        ? options.title
                        : route.name;
                    const isFocused = state.index === index;
                    const onPress = () => {
                      const event = navigation.emit({
                        type: "tabPress",
                        target: route.key,
                        canPreventDefault: true,
                      });
                      if (!isFocused && !event.defaultPrevented) {
                        navigation.navigate(route.name);
                      }
                    };
                    return (
                      <CustomMenuIcon
                        key={index}
                        index={index}
                        isFocused={isFocused}
                        onPress={onPress}
                        route={route}
                      />
                    );
                  })}
                </View>
              );
            };

            const styles = StyleSheet.create({
              container: {
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                backgroundColor: "#AAC7FF",
                borderTopWidth: 0,
                marginHorizontal: 16,
                borderRadius: 75 / 2,
                marginBottom: 20,
                height: 75,
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                // iOS shadow properties
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 4 },
                shadowOpacity: 0.3,
                shadowRadius: 4.65,
                // Android shadow properties
                elevation: 8,
              },
            });

            `,
				},
				{
					Title: "Creating custom icons",
					Text: `To create the custom icons, we need to create a new component called CustomMenuIcon. 
            This component will contain the tabs' icons and the animation logic for when the users tap on them. 
            Moreover, We can also define different styles for the active tab to indicate which tab is currently selected. 
            In this case, we added an animation to the icon when it is tapped and added color for when the icons are focused.`,
					Sample: `
            import { Animated, StyleSheet, TouchableOpacity } from "react-native";
            import React, { useEffect, useRef } from "react";
            import AntDesign from "@expo/vector-icons/AntDesign";

            interface DefProps {
              index: number;
              route: any;
              onPress: () => void;
              isFocused: boolean;
            }

            export const CustomMenuIcon = (props: DefProps) => {
              const { index, route, onPress, isFocused } = props;
              const scaleValue = useRef(new Animated.Value(1)).current;

              // Basic spring animation for the icons
              useEffect(() => {
                Animated.spring(scaleValue, {
                  toValue: isFocused ? 1.6 : 1,
                  friction: 5,
                  useNativeDriver: true,
                }).start();
              }, [isFocused]);

              return (
                <TouchableOpacity
                  activeOpacity={1}
                  onPress={onPress}
                  key={index}
                  style={styles.container}
                >
                  <Animated.View style={{ transform: [{ scale: scaleValue }] }}>
                    <AntDesign
                      name={
                        route.name === "Home"
                          ? "home"
                          : route.name === "Settings"
                          ? "setting"
                          : route.name === "Profile"
                          ? "user"
                          : "setting"
                      }
                      size={25}
                      color={isFocused ? "blue" : "black"}
                    />
                  </Animated.View>
                </TouchableOpacity>
              );
            };

            const styles = StyleSheet.create({
              container: {
                flex: 1,
                alignItems: "center",
                justifyContent: "center",
              },
            });
`,
				},
				{
					Title: "Using the bottom navigation",
					Text: `To use the bottom navigation in our app, we simply need to import the BottomNav component and add it to our main app component. 
          We can pass the tab components as children to the NavigationContainer component, 
          and it will take care of rendering the tabs and switching between them.`,
					Sample: `
            import "react-native-gesture-handler";
            import { StyleSheet } from "react-native";
            import { BottomNav } from "./src/navigation";
            import { NavigationContainer } from "@react-navigation/native";
                    
            export default function App() {
              return (
                <NavigationContainer>
                  <BottomNav />
                </NavigationContainer>
              );
            }
                    
            const styles = StyleSheet.create({
              container: {
                flex: 1,
                backgroundColor: "#fff",
                alignItems: "center",
                justifyContent: "center",
              },
            });

            `,
				},
				{
					Title: "Conclusion",
					Text: `In this article, we learned how to create a custom bottom navigation in React Native. 
            We created a custom bottom navigation component that allows users to navigate between screens using tabs. 
            We also learned how to style the bottom navigation and create custom icons for the tabs. 
            By following these steps, you can create a customized bottom navigation that suits your app's design and functionality.`,
				},
			],
		},
		{
			ID: 3,
			Title:
				"React Native: Persisting Data Using AsyncStorage, Redux Toolkit, and Redux Persist",
			Author: "Jose H  Mejia Munoz",
			Image: RN,
			SocialLink: "https://beacons.ai/jmejiamu",
			SocialNetwork: joseSocialNetwork,
			Content: [
				{
					Title: "Introduction",
					Text: `In this article, we will learn how to persist data in a React Native app.`,
				},
				{
					Title: "What is data persistence?",
					Text: `Data persistence refers to the ability of an application to store data between sessions.
          For example, This allows users to save their progress and settings in the app and retrieve them later.
          There are several ways to persist data in a React Native app, including using AsyncStorage, SQLite, and Realm.
          In this article, we will focus on using AsyncStorage to persist data in a React Native app.
          `,
				},
				{
					Title: "Using AsyncStorage, Redux Toolkit, and Redux Persist",
					Text: `AsyncStorage is a simple, key-value storage system that allows you to persist data in a React Native app.
          It is a built-in module that provides an easy way to store and retrieve data asynchronously. 
          Moreover, we will be using Redux Toolkit and Redux Persist to manage the state and persist the data in the app.
          Let's start by installing the required packages.`,
					Sample: `
          yarn add @reduxjs/toolkit
          yarn add redux-persist
          yarn add @react-native-async-storage/async-storage
          `,
				},
				{
					Title: "Setting up Redux Toolkit store",
					Text: `Redux Toolkit is a set of tools and best practices for managing state in a Redux application.
          It provides a simpler and more efficient way to write Redux code by reducing boilerplate and making common tasks easier.

          `,
					Sample: `
          import { combineReducers, configureStore } from "@reduxjs/toolkit";
          import {
          persistStore,
          persistReducer,
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          } from "redux-persist";
          import AsyncStorage from "@react-native-async-storage/async-storage";
          import dataSlice from "./dataSlice/dataSlice";

          const persistConfig = {
            key: "root",
            storage: AsyncStorage,
            whitelist: ["userData"],
          };
          const rootReducer = combineReducers({
            userData: dataSlice,
          });
          const persistedReducer = persistReducer(persistConfig, rootReducer);

          const store = configureStore({
            reducer: persistedReducer,

            middleware: (getDefaultMiddleware) =>
              getDefaultMiddleware({
                serializableCheck: {
                  ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
                },
              }),
          });

          const persistor = persistStore(store);
          export type RootState = ReturnType<typeof rootReducer>;
          export type AppDispatch = typeof store.dispatch;

          export { store, persistor };
          
          `,
				},
				{
					Title: "Adding the Redux Provider",
					Text: `Now that we have set up the Redux store, we need to add the Redux Provider to our app.
          The Redux Provider is a component that provides the Redux store to all components in the app.
          This allows us to access the store and dispatch actions from any component.
          `,
					Sample: `
          import { Provider } from "react-redux";
          import { store, persistor } from "./store";
          import { PersistGate } from "redux-persist/integration/react";
          import { NavigationContainer } from "@react-navigation/native";
          import { BottomNav } from "./src/navigation";
          import "react-native-gesture-handler";
          import { StyleSheet } from "react-native";
          import { StatusBar } from "expo-status-bar";

          export default function App() {
            return (
              <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                  <NavigationContainer>
                    <BottomNav />
                  </NavigationContainer>
                </PersistGate>
              </Provider>
            );
          }
          `,
				},
				{
					Title: "Creating a slice ",
					Text: `A slice is a collection of Redux reducer logic and actions for a single feature of your application.
          It is a way to organize your Redux code and keep related logic together.
          In this example, we will create a simple slice for managing user data.`,
					Sample: `
          import { createSlice } from "@reduxjs/toolkit";
          import { createSlice, PayloadAction } from "@reduxjs/toolkit";

          interface DataState {
            name: string;
            email: string;
          }

          const initialState: DataState = {
            name: "",
            email: "",
          };

          const dataSlice = createSlice({
            name: "data",
            initialState: initialState,
            reducers: {
              setData: (state, action: PayloadAction<DataState>) => {
                state.name = action.payload.name;
                state.email = action.payload.email;
              },
            },
          });

          export const { setData } = dataSlice.actions;
          export default dataSlice.reducer;
          `,
				},
				{
					Title: "Using the Redux store",
					Text: `Now that we have set up the Redux store and created a slice, we can use the store in our components to persist and retrieve data.
          We can dispatch actions to update the state and subscribe to changes in the state to update the UI.
          `,
					Sample: `
          import { useDispatch, useSelector } from "react-redux";
          import { setData } from "../store/dataSlice/dataSlice";
          import { RootState, AppDispatch } from "../store";

          export const Profile = () => {
            const dispatch = useDispatch<AppDispatch>();
            const userData = useSelector((state: RootState) => state.userData);

            const handleSave = () => {
              dispatch(setData({ name: "Alice", email: "test@gmail.com" }));
            }
          return (
            <View style={styles.container}>
              <Text>Name: {userData.name}</Text>
              <Text>Email: {userData.email}</Text>
              <Button title="Save" onPress={handleSave} />
            </View>
          );
        `,
				},
				{
					Title: "Conclusion",
					Text: `In this article, we learned how to persist data in a React Native app using AsyncStorage, Redux Toolkit, and Redux Persist.
          We set up the Redux store, created a slice, and used the store in our components to persist and retrieve data.
          By following these steps, you can persist data in your React Native app and provide a better user experience.
          Let mw know if you have any questions or comments.`,
				},
			],
		},
		{
			ID: 4,
			Author: "Reynaldo Mejia",
			Image: KT,
			Title: "Kotlin for Android Developers: A Comprehensive Guide Part 0x1",
			SocialLink: reynaldoSocialNetwork[0].Link,
			SocialNetwork: reynaldoSocialNetwork,
			Resource: [
				{
					ResourceLinkName: "Start practicing",
					ResourceLink: "https://play.kotlinlang.org/",
				}
			],
			Content: [
				{
					Title: "What is Kotlin?",
					Text:
						"Kotlin is a modern programming language created by JetBrains, designed to be statically " +
						"typed and fully interoperable with Java. Its syntax is similar to Java, but it introduces " +
						"powerful features that make development more efficient and less error-prone. Google officially" +
						" recommends Kotlin for Android app development due to its ability to simplify code, improve safety," +
						" and enhance developer productivity.",
				},
				{
					Text:
						"One of Kotlin's standout features is its built-in null safety, which helps prevent" +
						" NullPointerExceptions. Additionally, Kotlin offers coroutines, a robust mechanism for" +
						" handling asynchronous tasks in a straightforward manner. Furthermore, Kotlin powers " +
						"Jetpack Compose, Google's modern UI toolkit, enabling developers to build intuitive" +
						" and dynamic user interfaces with ease.",
				},
				{ Title: "Kotlin Syntax" },
				{
					Title: "Variables in Kotlin",
					Text:
						"In Kotlin, variables can be defined in two ways using the keywords var or val. Unlike" +
						" languages like C or Java, Kotlin supports both explicit and inferred type declarations.",
					Sample: `// C Programming
int age = 10;
char myCharacter = 'B';

// Java Programming
int age = 20;
String developerName = "Joe";
String programmingLanguage = "Java";`,
				},
				{
					Text: "Explicit Type Declaration: You can explicitly specify the type of a variable:",
					Sample: `var developerName: String = "Joe"
val programmingLanguage: String = "Kotlin"

var x: Float = 155.78f
var y: Float = 200.40f

var age: Int = 20`,
				},
				{
					Text: "Inferred Type Declaration: Kotlin's compiler can infer the type based on the assigned value:",
					Sample: `var developerName = "Joe"
val age = 20

var x = 155.78
var y = 200.40`,
				},
				{
					Text: "Note: Unlike C and Java, Kotlin does not require semicolons (;) at the end of statements.",
				},
				{ Title: "Mutable vs. Immutable Variables" },
				{
					Text: "Mutable Variables: Defined with var, these variables can be reassigned.",
					Sample: `var developerName = "Joe"
developerName = "Sofia"`,
				},
				{
					Text: "Immutable Variables: Defined with val, these variables cannot be reassigned after initialization.",
					Sample: `val developerName = "Joe"
developerName = "Sofia" // Error: 'val' cannot be reassigned
`,
				},
				{
					Title: "String Concatenation in Kotlin",
					Text: "Kotlin provides two ways to concatenate strings:",
					Sample: `// Using the $ symbol for string interpolation:
val name = "Joe"
val age = 22
val textOne = "Name: $name Age: $age"
println(textOne)

// Using the + operator:
val textTwo = "Name: " + name + " Age: " + age
println(textTwo)`,
				},
				{
					Title: "Null Safety in Kotlin",
					Text:
						"Null safety is one of Kotlin's features specifically designed to prevent NullPointerException. " +
						"In Kotlin, you can declare variables as nullable by adding the ? symbol to their type. To work with" +
						" these nullable variables safely, Kotlin provides three key tools:",
				},
				{
					Text:
						"1. Safe Call Operator (?.): Lets you access methods or properties of a nullable variable without" +
						" crashing your app if the variable is null.",
				},
				{
					Text: "2. Elvis Operator (?:): Allows you to provide a default value if a nullable variable is null.",
				},
				{
					Text:
						"3. Not-Null Assertion Operator (!!): Forces a nullable variable to be non-null, but crashes if" +
						" it’s actually use this operator with caution.",
				},
				{ Title: "Null Safety Example" },
				{
					Text: "Nullable Types: Variables can be declared nullable by appending ? to the type.",
					Sample: `var developerName: String? = null // Nullable
var age: Int = null // Error: 'null' cannot be assigned to a non-null type`,
				},
				{
					Text:
						"Safe Call Operator (?.): Allows safe access to methods or properties" +
						" of a nullable variable without throwing an exception.",
					Sample: `var developerName: String? = null
val length = developerName?.length // Returns null if developerName is null`,
				},
				{
					Text: "Elvis Operator (?:): Provides a default value when a nullable variable is null.",
					Sample: `val length = developerName?.length ?: 0 // Returns 0 if developerName is null`,
				},
				{
					Text:
						"Not-Null Assertion Operator (!!): Asserts that a variable is not null." +
						" Use this operator cautiously, as it throws a NullPointerException if the variable is null.",
					Sample: `val name: String? = null
val nameLength = name!!.length // Throws NPE if name is null
println(nameLength)
`,
				},
			],
		},
		{
			ID: 5,
			Author: "Reynaldo Mejia",
			Image: KT,
			SocialLink: reynaldoSocialNetwork[0].Link,
			SocialNetwork: reynaldoSocialNetwork,
			Resource: [
				{
					ResourceLinkName: "Kotlin Basic syntax",
					ResourceLink: "https://kotlinlang.org/docs/basic-syntax.html",
				}
			],
			Title: "Kotlin for Android Developers: A Comprehensive Guide Part 0x2",
			Content: [
				{
					Title: "Conditions in Kotlin",
					Text:
						"Conditions in Kotlin are similar to those in the Java programming language," +
						" but Kotlin introduces a new condition called when. The when condition is comparable" +
						" to the switch statement in Java, but it is more powerful and versatile. It allows you" +
						" to evaluate multiple values or conditions in a concise and readable way.",
				},
				{ Title: "Using if-else" },
				{
					Sample: `val age = 25 
if (age >= 18) {
	 println("You are an adult.") 
} else { 
	println("You are a minor.") 
}
`,
				},
				{ Title: "Using when" },
				{
					Sample: `val number = 5 
when { 
	number > 0 -> println("The number is positive") 
	number < 0 -> println("The number is negative")
	else -> println("The number is zero") 
}`,
				},
				{
					Text: "The when statement also allows you pass the subject to evaluate like so: ",
					Sample: `val age = 25 
when (age) { 
	in 0..17 -> println("You are a minor.") 
	in 18..64 -> println("You are an adult.") 
	else -> println("You are a senior citizen.") 
}`,
				},
				{
					Text: `when (age): This starts the when statement, checking the value of the age variable. 
in 0..17 -> println("You are a minor."): This branch checks if age is within the range of 0 to 17 (inclusive). If true, it prints "You are a minor."
in 18..64 -> println("You are an adult."): This branch checks if age is within the range of 18 to 64 (inclusive). If true, it prints "You are an adult."
else -> println("You are a senior citizen."): This is the default branch. If none of the previous conditions match, it prints "You are a senior citizen."`,
				},
				{
					Title: "Function",
					Text: `To define a function in Kotlin, you use the reserved keyword fun and follow this structure: fun functionName() { // body}.
By default, functions declared this way do not return Unit value, which is equivalent to void in other languages.
If you want the function to return a value, you can specify a return type like this: fun functionName(): ReturnType { // body }`,
					Sample: `fun printName() {
	println(“Sofia”)
}

fun getUserName() : String {
	return “Sofia”
}
`,
				},
				{
					Text: "Functions with parameters are defined this way  fun functionName(parameter: Type)  {// body}",
					Sample: `fun printUserName(name: String) {
	println(“Hello, \${name}”)	
}
`,
				},
				{
					Text: "Kotlin also allows you to create single-line functions like this: fun functionName() : ReturnType = Type",
					Sample:
						"fun factorial(n: Int): Int = if (n == 0) 1 else n • factorial(n - 1)",
				},
				{
					Title: "Lambda Function",
					Text: `A Lambda is an anonymous function, meaning a function without a name, that can be used as an expression. It is a way to reuse pieces of functionality in your code.
A Lambda function is defined like this:  (Type) -> Tipe = {}`,
					Sample: `val addNumbers: (Int, Int) -> Int = { a, b -> a + b }
	
val result = addNumbers(5, 3)

println(result) // Output: 8`,
				},
				{
					Text: "Here you have example of lambda function in Jetpack Compose: ",
					Sample: `@Composable 
fun MyButton(onButtonClick: () -> Unit) { 
	Button(onClick = onButtonClick) { 
		Text(text = "Click Me")
	} 
}
	
@Composable 
fun MyApp() {
	MyButton {
	  Log.i(“ECHO”, “Clicked!”)
	}
}
`,
				},
				{
					Title: "Extension functions",
					Text:
						"Extensions allow you to extend or add new functionality to a class without modifying it." +
						"To define an extension function, you set before the receiver type and then add the extended " +
						"functionality like this: fun Type.myFunctionality(): ReturnType",
					Sample: `fun String.capitalizeFirstLetter(): String {
	return this.substring(0, 1).toUpperCase() + this.substring(1)
}
val name = "sofia”
println(name.capitalizeFirstLetter()) // Sofia`,
				},
				{
					Title: "Casting and Type Coversion",
					Text: "Casting is the process of converting one type to another. Kotlin provide two ways to perform casting ",
				},
				{
					Title: "Safe Casting (as?)",
					Sample: `val obj: Any = "Kotlin"
val str: String? = obj as? String  // Safe cast
println(str) // Output: Kotlin

val num: Int? = obj as? Int       // Safe cast fails, returns null
println(num) // Output: null
`,
				},
				{
					Text: "If the cast is not posible, it return null instead of throwing an exception, This way is safe because it avoids runtime errors.",
				},
				{
					Title: "Unsafe Casting (as)",
					Sample: `val obj: Any = "Kotlin"
val str: String = obj as String  // Unsafe cast
println(str) // Output: Kotlin

val num: Int = obj as Int        // Throws ClassCastException`,
				},
				{
					Text: "The unsafe casting throws an exception if the cast is not posible.",
				},
				{
					Title: "Type Conversion ",
					Text: "Kotlin provides utility functions to convert between types for example toInt(), toDouble(), toString()",
					Sample: `val number: Int = 42
val text: String = number.toString()  // Converts Int to String
println(text) // Output: "42"

val doubleValue: Double = text.toDouble() // Converts String to Double
println(doubleValue) // Output: 42.0`,
				},
			],
		},
		{
			ID: 6,
			Title: "Kotlin for Android Developers: Classes, Constructors, Interface and Inheritance part 0x1",
			Image: KT,
			Author: "Reynaldo Mejia",
			SocialLink: reynaldoSocialNetwork[0].Link,
			Resource: [
				{
					ResourceLinkName: "Kotlin Classes",
					ResourceLink: "https://kotlinlang.org/docs/classes.html",
				},
				{
					ResourceLinkName: "Compain Object",
					ResourceLink: "https://kotlinlang.org/docs/object-declarations.html#companion-objects"
				}
			],
			SocialNetwork: reynaldoSocialNetwork,
			Content: [
				{
					Title: "What is a Class?"
				},
				{
					Text: "A class allows us to create a new data type. It serves as a model to organize attributes and methods. " +
						"A class consists of attributes, which are data types that describe the state of an object. Example of attributes:",
					Sample: `val name: String  
val lastName: String  
val age: Int  
`
				},
				{
					Text: "A class also consists of behaviors or methods. A method is a function inside a class that " +
						"allows us to modify or access attributes. Example:",
					Sample: `fun getUserName(): String { return name }`
				},
				{
					Title: "Access Modifiers",
					Text: "Access modifiers are keywords that define the" +
						" visibility of a class member (attribute or method) outside the class:"
				},
				{
					Title: "public",
					Text: "public: Members marked as public are accessible from anywhere, including other classes and packages."
				},
				{
					Title: "protected",
					Text: "protected: Members marked as protected are accessible within the same package and subclasses."
				},
				{
					Title: "private",
					Text: "private: Members marked as private are only accessible within the class where they are declared." +
						" They cannot be accessed by other classes, even within the same package."
				},
				{
					Title: "Constructor and Object Instantiation",
					Text: "A constructor initializes an object's state or attributes. Kotlin allows defining constructors" +
						" in different ways. You can define a constructor directly after the class name or use the constructor keyword." +
						" To instantiate an object in Kotlin, the class constructor is called like a function, with or without arguments, depending on how it was defined."
				},
				{
					Title: "Primary Constructor",
					Text: "In this example, the constructor is defined within parentheses after the class name:",
					Sample: `class Employee(private var name: String, private var email: String) {

    fun getName(): String = name  
    fun getEmail(): String = email  
    
}

fun main() {
    val maria = Employee("Maria", "maria@mail.com")  
    println(maria.getName())  
    println(maria.getEmail())  
}`
				},
				{
					Title: "Secondary Constructor",
					Text: "This approach is similar to other programming languages, where attributes are initialized inside the constructor:",
					Sample: `class Employee {

    private var name: String  
    private var email: String  
    
    constructor(name: String, email: String) {
        this.name = name  
        this.email = email  
    }
    
    fun getName(): String = name  
    fun getEmail(): String = email  
    
}

fun main() {
    val sofia = Employee("Sofia", "sofia@mail.com")  
    println(sofia.getName())  
    println(sofia.getEmail())  
}`
				},
				{
					Title: "Multiple Constructors",
					Text: "You can define multiple constructors using different parameter sets:",
					Sample: `class Employee {

    private var name: String? = null  
    private var email: String? = null  
    
    // Empty constructor  
    constructor()  
    
    // Constructor with parameters  
    constructor(name: String, email: String) {
        this.name = name  
        this.email = email  
    }
    
    constructor(name: String) {
        this.name = name  
    }
    
    
    fun getName(): String? = name  
    fun getEmail(): String? = email  
    
}

fun main(){

  val maria = Employee()
  println(maria.getName())
  println(maria.getEmail())
  
  val sofia = Employee("Sofia")
  println(sofia.getName())
  println(sofia.getEmail())
 
}`
				},
				{
					Title: "init Blocks in Kotlin",
					Text: "The init block allows executing code after an instance of a class is created." +
						" It is commonly used to initialize attributes and perform setup tasks.",
					Sample: `class Person(var firstName: String, var lastName: String) {
    val fullName: String  

    init {
        fullName = "$firstName $lastName"  
        println("Initializing Person with full name: $fullName")  
    }

    val firstLetterOfLastName: Char  

    init {
        firstLetterOfLastName = lastName[0]  
        println("The first letter of the last name is: $firstLetterOfLastName")  
    }

    fun introduce() {
        println("Hello, my name is $fullName.")  
    }
}

fun main() {
    val person = Person("Maria", "Doe")  
    person.introduce()  
}`
				},
				{ Text: "This ensures that when a new Person object is created, its fullName and firstLetterOfLastName attributes are initialized automatically." },
				{
					Title: "Companion Object",
					Text: "A companion object is associated with a class rather than an instance of the class." +
						" It is similar to the definition of static members in languages like Java." +
						" Companion objects are defined inside a class, and their properties or methods can be accessed using the class name." +
						" Some common use cases for companion objects include creating class instances and defining constants.",
					Sample: `class NetworkRequest(val url: String) {

    companion object {
        private const val BASE_URL = "https://api.learncoding.me/"
        
        fun createNewPost(endpoint: String): String {
            return BASE_URL + endpoint
        }
    }
      
}

fun main() {
   val net = NetworkRequest.createNewPost("kotlin")
   println(net)
}`
				},
				{
					Title: "Conclusion",
					Text: "In this post, we explored classes and constructors in Kotlin," +
						" which are fundamental building blocks for organizing data and behavior" +
						" in an application. We covered access modifiers," +
						" primary and secondary constructors, multiple constructors," +
						" and init blocks, which help in initializing objects efficiently.",
				}
			]
		},
		{
			ID: 7,
			Author: "Reynaldo Mejia",
			SocialLink: reynaldoSocialNetwork[0].Link,
			Title: "Kotlin for Android Developers: Classes, Constructors, Interface and Inheritance part 0x2",
			Resource: [
				{
					ResourceLinkName: "Kotlin Interfaces",
					ResourceLink: "https://kotlinlang.org/docs/interfaces.html"
				},
				{
					ResourceLinkName: "Kotlin Inheritance",
					ResourceLink: "https://kotlinlang.org/docs/inheritance.html"
				},
				{
					ResourceLinkName: "Kotlin Abstract Classes",
					ResourceLink: "https://kotlinlang.org/docs/classes.html#abstract-classes"
				}
			],
			SocialNetwork: reynaldoSocialNetwork,
			Image: KT,
			Content: [
				{
					Title: "Inheritance in Kotlin",
					Text: "Inheritance allows a class to reuse properties and behaviors from another class." +
						" A superclass (or base class) contains the properties and methods that will be inherited" +
						" by its subclasses (or derived classes)." +
						" In Kotlin, a class must be explicitly marked as open to allow inheritance. ",
					Sample: `open class Person(var name: String, var lastName: String) {

    open fun printPersonInformation() {
        println("First Name: $name, Last Name: $lastName")
    }
}`
				},
				{
					Text: "To inherit from a class, use : just like with interfaces:",
					Sample: `class Manager(
    name: String,
    lastName: String,
    var managerID: Int,
    var storeNumber: Int
) : Person(name, lastName) { 
    
    fun printManagerInformation() {
        super.printPersonInformation()
        println("ID: $managerID, Store Number: $storeNumber")
    }
}

fun main() {
    val sofia = Manager("Sofia", "Doe", 1, 7)
    sofia.printManagerInformation()
}`
				},
				{
					Title: "Abstract Class",
					Text: "An abstract class serves as a blueprint for other classes. It defines properties and behaviors but cannot be" +
						" instantiatedon its own. When a class inherits from an abstract class, it must implement all abstract methods." +
						" To declare an abstract class in Kotlin, use the abstract keyword followed by class and the class name, like this:",
					Sample: `abstract class Shape {
    abstract fun area(): Double
    abstract val perimeter: Double
    var color: String = "Unknown" 

    fun describe() { 
        println("This shape is $color.")
    }

    fun changeColor(newColor: String) {
        color = newColor
    }
}`
				},
				{
					Text: "To inherit from an abstract class, you must override all abstract methods:",
					Sample: `class Circle(val radius: Double) : Shape() {
    override fun area(): Double {
        return Math.PI • radius • radius
    }

    override val perimeter: Double
        get() = 2 • Math.PI • radius
}`
				},
				{
					Title: "Creating an Instance",
					Text: "Since Shape is abstract, it cannot be instantiated directly. However, we can create an" +
						" instance of Circle, which extends Shape:",
					Sample: `fun main() {
    val myCircle = Circle(5.0)
    println("Initial color of the circle: \${myCircle.color}") 

    myCircle.changeColor("Red")
    println("Color of the circle after setting: \${myCircle.color}") 

    myCircle.describe()
}`
				},
				{
					Title: "Interfaces in Kotlin",
					Text: "An interface defines a set of contracts that a class must implement. These contracts consist" +
						" of public methods that specify behaviors or functionalities. However, an interface does not provide" +
						" any implementation—only method declarations. Here’s an example of how to declare an interface in Kotlin:",
					Sample: `interface Vehicle {
    fun startEngine(): String
    fun stopEngine(): String
}`
				},
				{
					Title: "Implementing an Interface",
					Text: "To implement an interface in Kotlin, use : after the class name, followed by the interface name:",
					Sample: `interface Vehicle {
    fun startEngine(): String
    fun stopEngine(): String
}

class Car : Vehicle {
    override fun startEngine(): String = "Car Engine Start"
    override fun stopEngine(): String = "Car Engine Stop"
}

class Truck : Vehicle {
    override fun startEngine(): String = "Truck Engine Start"
    override fun stopEngine(): String = "Truck Engine Stop"
}

fun main() {
    val car = Car()
    println(car.startEngine())

    val truck = Truck()
    println(truck.startEngine())
    println(truck.stopEngine())
}`
				},
				{
					Title: "Conclusion",
					Text: "In this post, we explored interfaces, inheritance, and abstract classes in Kotlin. Interfaces" +
						" define a set of behaviors that a class must implement, while inheritance allows a class to" +
						" reuse properties and methods from another class. These features enable code reuse, polymorphism," +
						" and scalability in software development."
				},
				{
					Text: "Additionally, abstract classes serve as blueprints for other classes, providing both abstract" +
						" methods (which must be implemented by subclasses) and concrete methods " +
						"(which can be inherited directly). Unlike interfaces, abstract classes" +
						" can hold state through properties, making them useful when designing a" +
						" common base for related objects. They offer a structured approach to" +
						" enforcing consistency across multiple classes while still allowing flexibility in their implementations."
				}
			]
		},
		{
			ID: 8,
			Title: "Kotlin for Android Developers: Inline Functions",
			Author: "Reynaldo Mejia",
			Image: KT,
			SocialLink: reynaldoSocialNetwork[0].Link,
			SocialNetwork: reynaldoSocialNetwork,
			Resource:[
				{
					ResourceLinkName:"Inline Functions",
					ResourceLink:"https://kotlinlang.org/docs/inline-functions.html"
				},
				{
					ResourceLinkName:"Higher-order functions and lambdas",
					ResourceLink:"https://kotlinlang.org/docs/lambdas.html"
				}
			],
			Content: [
				{
					Text: "When developing Android apps with Kotlin, you'll often work with functions as first-class citizens." +
						" This means you can store functions in variables, pass them as parameters, or return them."
				},
				{
					Title: "Callback Functions in Kotlin",
					Text: "When you pass lambdas or functions as parameters, Kotlin treats them as objects behind the scenes." +
						" This adds memory overhead due to object creation and can impact performance." +
						" To avoid this, Kotlin offers inline functions. An inline function tells the" +
						" compiler to copy the function’s code directly at the call site, reducing overhead. Inline function syntax:",
					Sample: `inline fun doTwice(action: () -> Unit) {
    action()
}`
				},
				{
					Title: "Example: Inline Function",
					Sample: `inline fun greet(name: String, action: (String) -> Unit) {
    println("Preparing greeting...")
    action(name)
}

fun main() {
    greet("Alex") { name ->
        println("Hello, $name!")
    }
}`,
				},
				{ Text: "At compile time, the lambda passed to greet is inlined—meaning there's no extra function object created." },
				{
					Title: "return Behavior in Inline Functions",
					Text: "When using inline functions, Kotlin allows non-local returns from the lambda. Example: Non-local Return",
					Sample: `inline fun runIfTrue(condition: Boolean, action: () -> Unit) {
	if (condition) action()
}

fun test() {
	runIfTrue(true) {
		println("Inside lambda")
		return  // Allowed because \`runIfTrue\` is inline
	}
	println("This line is not reached if return is called inside lambda")
}
`,
				},
				{
					Text: "Here, return exits from the calling function test() because runIfTrue is inline." +
						" If the function isn't inlined, you'd get a compiler error using return this way."
				},
				{
					Sample: `inline fun measureTimeMillis(block: () -> Unit): Long {
    val start = System.currentTimeMillis()
    block()
    return System.currentTimeMillis() - start
}

fun main() {
    val time = measureTimeMillis {
        Thread.sleep(1000)
    }
    println("Time taken: $time ms")
}`
				},
				{
					Text: "In this example, When main calls measureTimeMillis, the compiler will insert the code of measureTimeMillis" +
						"directly into main instead of performing a function call."
				},
				{
					Title: "crossinline: Restricting Return Behavior",
					Text: "Sometimes, you want to inline a function but restrict return inside its lambda. This is where crossinline helps." +
						" Use crossinline when you want to inline a lambda but prevent non-local returns.",
					Sample: `inline fun runOnUiThread(crossinline task: () -> Unit) {
    Thread {
        task()  // Non-local return NOT allowed here
    }.start()
}`
				},
				{
					Text:"Here, using return inside the task() lambda would be illegal because the lambda runs in a different context"+
					" (thread). crossinline ensures the developer doesn’t accidentally use a return where it's not safe."
				},
				{
					Title:"Conclusion",
					Text:"Kotlin treats functions as first-class citizens, making it easy to build flexible and reusable code using"+
					" callbacks and higher-order functions. By marking functions as inline, you can eliminate the overhead of lambda"+
					" object creation, leading to more efficient execution—especially in performance-critical parts of your Android apps."+
					" Inline functions also enable powerful control-flow behavior like non-local returns. When needed, crossinline helps"+
					" prevent unintended returnstatements, ensuring your lambdas behave safely in contexts like background threads."
				}
			]
		},
		{
			ID: 9,
			Title: "Kotlin for Android Developers: Coroutines",
			Author: "Reynaldo Mejia",
			Image: KT,
			SocialLink: reynaldoSocialNetwork[0].Link,
			SocialNetwork: reynaldoSocialNetwork,
			Resource: [
				{
					ResourceLinkName: "Main Thread",
					ResourceLink: "https://developer.android.com/guide/components/processes-and-threads"
				},
				{
					ResourceLinkName: "Kotlin Coroutines",
					ResourceLink: "https://developer.android.com/kotlin/coroutines"
				},
				{
					ResourceLinkName: "Kotlin Coroutines Overview",
					ResourceLink: "https://kotlinlang.org/docs/coroutines-overview.html#how-to-start"
				},
				{
					ResourceLinkName: "Kotlin Coroutines Basics",
					ResourceLink: "https://kotlinlang.org/docs/coroutines-basics.html"
				},
				{
					ResourceLinkName: "Suspend Functions",
					ResourceLink: "https://kotlinlang.org/docs/composing-suspending-functions.html"
				},
				{
					ResourceLinkName: "Launch",
					ResourceLink: "https://kotlinlang.org/api/kotlinx.coroutines/kotlinx-coroutines-core/kotlinx.coroutines/launch.html"
				}
			],
			Content: [
				{
					Title: "What is a Thread?",
					Text: "A thread is an execution unit within a process that allows tasks to run independently or within another thread." +
						" Essentially, a thread consists of instructions or tasks that can execute simultaneously or in parallel with other threads.",
				},
				{
					Title: "Android Main Thread",
					Text: "The main thread (also known as the UI thread) is created when an application launches. It is crucial because it is" +
						" responsible for dispatching user interface elements such as widgets." +
						" It's important to note that the system does not create a separate UI thread for each component; instead, all" +
						" components run on the same UI thread. If long-running operations—such as network access or database connections—are" +
						" executed on the UI thread, it can become blocked, leading to an ANR (Application Not Responding) error. To prevent this," +
						" long-running operations should be dispatched to a background thread."
				},
				{
					Title: "Kotlin Coroutines",
					Text: "Asynchronous operations play a significant role in mobile development. Kotlin Coroutines offer a design pattern" +
						" that simplifies the execution of asynchronous tasks in a flexible and efficient manner." +
						" As mentioned earlier, if an operation takes several seconds to complete, it can cause" +
						" performance issues in an application. Coroutines help solve this by efficiently managing" +
						" time-consuming tasks without blocking the main thread." +
						" A coroutine is like an efficient worker inside your app. It handles time-consuming tasks" +
						" by pausing when needed (e.g., waiting for an API response, database connection," +
						" or file download) and allowing other tasks to proceed. Once the waiting task is ready, it" +
						" resumes execution from where it left off."
				},
				{
					Title: "Suspend Functions",
					Text: "A suspend function is fundamental to coroutines, enabling asynchronous programming." +
						" The suspend keyword indicates that a function can be paused and resumed, allowing operations" +
						" to complete without blocking other threads (such as the Main/UI thread). Example of a Suspend Function:",
					Sample: `import kotlinx.coroutines.•

suspend fun fetchData(): String {
    delay(1000L)
    return "{ data: [ {name: Sofia, skills: [Go, Java, JavaScript]},{name: Joe, skills: [Typescript, Kotlin]} ] }"
}

fun main() = runBlocking {
    println("Start")
    val result = fetchData()
    println(result)
    println("End")
}`
				},
				{
					Text: "In this example, we define a suspend function that waits for 1 second before returning a string." +
						" The runBlockingfunction creates a coroutine that blocks the current thread until fetchData() completes execution."
				},
				{
					Title: "Dispatchers",
					Text: "Dispatchers determine which thread a coroutine will execute on. Some common dispatchers in Kotlin are:"
				},
				{
					Title: "Dispatcher.Main (UI thread)",
					Text: "Responsible for updating UI components like text, buttons, and click events."
				},
				{
					Title: "Dispatcher.IO (Background thread)",
					Text: "Handles operations such as downloading images, reading/writing to a database, and network communication."
				},
				{
					Title: "Dispatcher.Default (CPU-intensive tasks) ",
					Text: "Used for complex calculations, data analysis, and operations requiring high computational power."
				},
				{
					Title: "Analogy",
					Text: "Imagine an office with three departments:"
				},
				{
					Text: "1. Dispatcher.Main (CEO's Office)  Manages anything that interacts with users (UI)." +
						" 2. Dispatcher.IO (Data Processing Department) Handles incoming/outgoing data like API requests and file operations." +
						" 3. Dispatcher.Default (Research & Analytics Department) Handles CPU-heavy tasks like complex calculations"
				},
				{
					Title: "Launch",
					Text: "launch is a coroutine builder used to start a new coroutine. It is typically used" +
						" for tasks that do not return a result. The launch constructor starts a coroutine without" +
						" blocking the current thread. Example of Launching a Coroutine",
					Sample: `import kotlinx.coroutines.•

fun main() {
    runBlocking { // Creates a coroutine scope
        val job = launch { // Launches a new coroutine
            delay(1000L) // Suspends the coroutine for 1 second
            println("World!")
        }
        println("Hello,")
        job.join() // Waits for the coroutine to complete
    }
}`
				},
				{
					Text: `In this example: 1. runBlocking creates a coroutine scope.
2. launch starts a coroutine that delays for 1 second before printing "World!".
3. The main thread continues execution and prints "Hello,".
4. job.join() ensures that "World!" is printed before the program exits.`
				},
				{
					"Title": "Conclusion",
					Text: "Threads and coroutines are essential in Kotlin for handling asynchronous tasks efficiently." +
						" The Main thread is responsible for UI updates, while background operations should be delegated" +
						" to secondary threads using coroutines. Suspend functions and dispatchers help manage execution smoothly," +
						" improving performance and responsiveness in Android applications."
				}
			]
		},
		{
			ID: 10,
			Title: "Kotlin for Android Developers: Flows",
			Author: "Reynaldo Mejia",
			Image: KT,
			SocialLink: reynaldoSocialNetwork[0].Link,
			SocialNetwork: reynaldoSocialNetwork,
			Resource: [
				{
					ResourceLinkName: "Kotlin Flows",
					ResourceLink: "https://developer.android.com/kotlin/flow"
				},
				{
					ResourceLinkName: "Flows Builders",
					ResourceLink: "https://kotlinlang.org/api/kotlinx.coroutines/kotlinx-coroutines-core/kotlinx.coroutines.flow/-flow/"
				},
				{
					ResourceLinkName: "StateFlow and SharedFlow",
					ResourceLink: "https://developer.android.com/kotlin/flow/stateflow-and-sharedflow"
				},
				{
					ResourceLinkName: "StateFlow",
					ResourceLink: "https://kotlinlang.org/api/kotlinx.coroutines/kotlinx-coroutines-core/kotlinx.coroutines.flow/-state-flow/"
				},
				{
					ResourceLinkName: "SharedFlow",
					ResourceLink: "https://kotlinlang.org/api/kotlinx.coroutines/kotlinx-coroutines-core/kotlinx.coroutines.flow/-shared-flow/"
				}
			],
			Content: [
				{
					Title: "What are Flows?",
					Text: "Flows are asynchronous sequences that operate similarly to coroutines." +
						" A flow handles tasks such as network requests or database connections without blocking the main thread." +
						" A flow emits data sequentially, one item at a time, ensuring that each emitted value is processed in order."
				},
				{
					Title: "Flow Entities",
					Text: "The flow process consists of three main entities: Producer, Intermediaries, and Consumer."
				},
				{ Text: `Producer: Responsible for generating data that will be emitted into the flow. This data is produced asynchronously.` },
				{ Text: `Intermediaries (optional): Modify or transform the emitted data before it reaches the consumer.` },
				{ Text: `Consumer: The entity that collects and processes the emitted data.` },
				{
					Title: "Types of Flows",
					Text: "There are two primary types of flows in Kotlin:",
				},
				{ Text: "Cold Flow: This type of flow does not start emitting values until it has at least one active collector (consumer)." },
				{ Text: "Hot Flow: Unlike Cold Flow, Hot Flow emits values regardless of whether there is an active collector." },
				{
					Title: "Flow Builders",
					Text: "Kotlin provides multiple ways to create flows:"
				},
				{ Text: "flowOf(): Creates a flow with a predefined set of values." },
				{ Text: "asFlow(): An extension function that converts any type into a flow." },
				{ Text: "flow {}: A builder function that allows creating flows based on sequential calls.." },
				{ Text: "channelFlow {}: Allows building flows from potentially concurrent calls to the send function." },
				{ Text: "MutableStateFlow & MutableSharedFlow: Used to create hot flows that can be updated directly." },
				{
					Title: "Creating a Flow",
					Text: "To create a flow, first, define the producer using the flow builder:",
					Sample: `import kotlinx.coroutines.•
import kotlinx.coroutines.flow.•

fun numberFlow(): Flow<Int> = flow {
    for (i in 1..5) {
        delay(500) // Wait for 500 milliseconds
        emit(i) // Emit the next number
    }
}`
				},
				{
					Text: "To collect the emitted values from the producer:",
					Sample: `fun main() = runBlocking {
    println("Starting to collect the flow...")
    numberFlow().collect { value ->
        println("Received: $value")
    }
    println("Flow collection finished.")
}`
				},
				{
					Title: "Operators",
					Text: "Flows provide various operators to manipulate or transform data, similar to list functions. Some of the most common operators include:",
				},
				{ Text: "map{}: Transforms each emitted value by applying a function. Example: .map { it • 10 }" },
				{ Text: "filter{}: Filters emitted values based on a condition. Example: .filter { it > 53 }" },
				{ Text: "collect{}: Collects all emitted values from the flow." },
				{
					Title: "Example using Flow Operators",
					Sample: `fun main() = runBlocking {
    println("Starting to collect the flow...")
    numberFlow()
        .filter { value -> value % 2 == 0 } // Filters even numbers
        .collect { value ->
            println("Received: $value")
        }
    println("Flow collection finished.")
}`
				},
				{
					Title: "StateFlow and SharedFlow",
					Text: "StateFlow and SharedFlow are part of the Kotlin Coroutines library, allowing us" +
						" to emit updated states and share values with multiple consumers."
				},
				{
					Title: "StateFlow",
					Text: "StateFlow represents a single state that continuously emits updated values to collectors." +
						" The current state can be accessed through the .value property. Example of StateFlow:",
					Sample: `class StockMarketViewModel(
    private val stockMarketRepository: StockMarketRepository
) : ViewModel() {

    private val _uiState = MutableStateFlow(StockMarketState.Success(emptyList()))
    val uiState: StateFlow<StockMarketState> = _uiState

    init {
        viewModelScope.launch {
            stockMarketRepository.stockLatestNews
                .collect { stock -> 
                    _uiState.value = StockMarketState.Success(stock) 
                }
        }
    }
}

sealed class StockMarketState {
    data class Success(val stock: List<Stock>) : StockMarketState()
    data class Error(val error: String) : StockMarketState()
}`
				},
				{ Text: "In this example:" },
				{ Text: " _uiState is a MutableStateFlow that holds the current state." },
				{ Text: "uiState is the exposed StateFlow, which collects stock market updates from the repository." },
				{ Text: "When new stock data arrives, _uiState.value is updated, notifying all collectors." },
				{
					Title: "SharedFlow",
					Text: "SharedFlow is a hot flow that can emit values to multiple collectors." +
						" Unlike StateFlow, it does not store a single state but instead broadcasts" +
						" emitted values to active subscribers. Example of SharedFlow",
					Sample: `class CounterViewModel : ViewModel() {

    private val _count = MutableSharedFlow<Int>(replay = 1) // Replay the last emitted value
    val count: SharedFlow<Int> = _count.asSharedFlow()

    private var currentCount = 0

    fun incrementCounter() {
        currentCount++
        viewModelScope.launch {
            _count.emit(currentCount)
        }
    }
}`,
				},
				{ Text: "In this example:" },
				{ Text: "_count is a MutableSharedFlow with replay = 1, meaning it will remember and emit the last value to new collectors." },
				{ Text: "count is the exposed SharedFlow, ensuring multiple collectors receive the latest count updates." },
				{ Text: "The incrementCounter() function updates the counter and emits the new value." },
				{ Text: "StateFlow is ideal for UI state management, while SharedFlow is useful for event-driven communication across multiple components." },
				{
					Title: "Conclusion",
					Text: "Flows are a powerful way to handle asynchronous data streams in Kotlin." +
						" They enable efficient execution of background tasks, such as network calls" +
						" or database operations, without blocking the main thread. By leveraging" +
						" different flow types, builders, and operators, developers can create scalable and reactive applications."
				},
				{ Text: "Among these, StateFlow and SharedFlow play a crucial role in managing state and event-driven communication." },
				{
					Text: "StateFlow is designed for managing stateful data that updates over time." +
						" It always holds the latest value and ensures that collectors receive the most" +
						" recent state immediately upon subscription. This makes it ideal for UI state" +
						" management, where components need to react to changes efficiently."
				},
				{
					Text: "SharedFlow is a hot flow that allows multiple collectors to receive emitted" +
						" values in real-time. It is useful for event-driven scenarios such as notifications," +
						" messages, or UI events, where the latest emitted data needs to be shared among different parts of an application."
				}
			],
		},
		{
			ID: 11,
			Title: "Kotlin for Android Developers: Services Part 0x1",
			Author: "Reynaldo Mejia",
			Image: KT,
			SocialLink: reynaldoSocialNetwork[0].Link,
			SocialNetwork: reynaldoSocialNetwork,
			Resource: [
				{
					ResourceLinkName: "Android Services",
					ResourceLink: "https://developer.android.com/develop/background-work/services"
				},
				{
					ResourceLinkName: "Services in Android with Example",
					ResourceLink: "https://www.geeksforgeeks.org/services-in-android-with-example/"
				}
			],
			Content: [
				{
					Title: "What is a Service?",
					Text: "A service is a component in Android that runs on the main thread and does not have a user" +
						" interface. Services can perform operations in the foreground or background, making them essential" +
						" for tasks that should continue running independently of the user interface.",
				},
				{ Title: "Types of Services" },
				{
					Title: "Foreground Service",
					Text: "A foreground service performs operations that are visible to the user. These actions are typically displayed" +
						" through UI components, such as notifications, allowing user interaction." +
						" Example: A music player running as a foreground service displays a persistent notification so users can play," +
						" or stop the audio.",
				},
				{
					Title: "Background Service",
					Text: "A background service runs operations that are not directly visible to the user." +
						" Example: A stock market application fetching real-time price updates. Since the prices" +
						" change constantly, a background service is well-suited for this type of operation."
				},
				{
					Title: "Bound Service",
					Text: "A bound service allows other application components (such as activities, fragments, or even other services)" +
						" to bind and interact with it. Unlike a standalone service started with startService(), a bound service" +
						" provides a client-server interface, enabling:"
				},
				{ Text: "Method calls: Clients can directly invoke methods on the service." },
				{ Text: "Data exchange: The service can return values to the client." },
				{ Text: "Continuous communication: The service remains active while at least one client is bound." },
				{
					Title: "Creating a Service",
					Text: "To create a service, extend the Service class and override lifecycle methods. Here are some key methods:"
				},
				{ Text: "onStartCommand(): Called when the service is explicitly started." },
				{ Text: "onBind(): Used when components bind to the service, returning an IBinder interface." },
				{ Text: "onCreate(): Invoked before onStartCommand() or onBind(). If the service is already running, this method is not called again." },
				{ Text: "onDestroy(): Called when the service is stopped. It should be used to clean up resources such as listeners, threads, or receivers." },
				{
					Title: "Declaring a Service",
					Text: "To use a service in an Android app, it must be declared in AndroidManifest.xml:",
					Sample: `<application
    ... attributes ...>

    <activity
        ... attributes ...>
        <intent-filter>
            <action android:name="android.intent.action.MAIN" />
            <category android:name="android.intent.category.LAUNCHER" />
        </intent-filter>
    </activity>

    <service
        android:name=".MyWorkService" />

</application>`
				},
				{
					Title: "Conclusion",
					Text: "Services play a crucial role in Android development, enabling background operations that persist beyond" +
						" the lifecycle of an activity or fragment. Whether running in the foreground, background, or bound mode, services" +
						" allow for better resource management and improved user experiences. By understanding the different service types" +
						" and their use cases, developers can design more efficient Android applications."
				}
			]
		},
		{
			ID: 12,
			Title: "Kotlin for Android Developers: Creating a Service Part 0x2",
			Author: "Reynaldo Mejia",
			Image: KT,
			SocialLink: reynaldoSocialNetwork[0].Link,
			SocialNetwork: reynaldoSocialNetwork,
			Resource: [
				{ ResourceLinkName: "Timer Code", ResourceLink: "https://github.com/redmejia/timer-service" },
				{ ResourceLinkName: "Android Services", ResourceLink: "https://developer.android.com/guide/components/services" }
			],
			Content: [
				{ Text: "In this tutorial, we will build a timer application to practice using Services in Android." },
				{
					Title: "Setting Up the Project",
					Text: "After creating your project, follow these steps:"
				},
				{ Text: "1. Create a new class named TimerService in the root of your project. This class must extend Service." },
				{ Text: "• Inside the companion object, define three constants for managing notifications in the timer service." },
				{ Text: "• Declare three new variables:" },
				{ Text: "1. job: A background coroutine that will run the timer." },
				{ Text: "2. remainingTime: A variable that represents the timer duration, which will be updated every second." },
				{ Text: "3. notificationManager: Responsible for handling notifications in the service." },
				{ Text: "2. Override the onBind method and return null since we are not binding this service to an activity." },
				{ Text: "3. Override the onCreate method. This method is called before onStartCommand. Here, we:" },
				{ Text: "• Initialize the notificationManager." },
				{ Text: "• Create a notification channel to manage timer notifications." },
				{ Text: "4. Implement onStartCommand, which defines the start and stop logic for the timer service." },
				{
					Text: "5. Create the startTimer method, which takes the timer duration as a parameter. Inside this method," +
						" we start the service using startForeground() with a notification ID and a notification object."
				},
				{
					Text: "6. Define the timerNotification method, which takes the remaining time as a parameter and constructs" +
						" the notification content."
				},
				{ Text: "7. Implement the timer method, which starts a coroutine that:" },
				{ Text: "• Runs on the main thread." },
				{ Text: "• Decreases remainingTime every second." },
				{ Text: "• Updates the notification with the current time." },
				{ Text: "• Stops the service when the timer reaches zero." },
				{
					Text: "8. Define the notificationChannel method, which creates a channel for notifications." +
						" This is necessary for Android Oreo (API 26+) and ensures that notifications can be properly displayed."
				},
				{ Text: "9. Implement the updateTimerNotification method, which updates the notification's content (the remaining time)." },
				{ Text: "10. Create a formatter method, which formats the time in minutes:seconds (e.g., 05:34)." },
				{ Text: "11. Use an enum TimerActions to handle actions like START and STOP the timer." },
				{ Text: "12. Override onDestroy, which cleans up resources by canceling the coroutine job." },
				{
					Title: "Registering the TimerService in AndroidManifest.xml",
					Text: "Now, we need to declare the TimerService and request permissions for notifications and foreground services in AndroidManifest.xml.",
					Sample: `<manifest xmlns:android="http://schemas.android.com/apk/res/android"
    xmlns:tools="http://schemas.android.com/tools">

<application
    ... attributes ... >

	<uses-permission android:name="android.permission.POST_NOTIFICATIONS" />	
	<uses-permission android:name="android.permission.FOREGROUND_SERVICE" />

    <activity
        ... attributes ...>
        <intent-filter>
            <action android:name="android.intent.action.MAIN" />
            <category android:name="android.intent.category.LAUNCHER" />
        </intent-filter>
    </activity>

    <service
        android:name=".TimerService"
        android:exported="false"
        android:foregroundServiceType=""/>
</application>
</manifest>`
				},
				{ Text: "The android:name attribute registers the TimerService." },
				{ Text: "The android:exported attribute defines whether other apps can access the service (false means only this app can use it)." },
				{
					Text: "The foregroundServiceType defines the type of service" +
						" (e.g., camera, location). Here, it is left empty, but you can choose an appropriate type based on your app's functionality."
				},
				{
					Title: "TimerService Code Implementation",
					Text: "Here is the full implementation of the TimerService class:",
					Sample: `class TimerService : Service() {

    companion object {
        const val CHANNEL_ID = "TimerChannel"
        const val NOTIFICATION_ID = 1
        const val EXTRA_DURATION = "DURATION"
    }

    private var job: Job? = null
    private var remainingTime = 0
    private var notificationManager: NotificationManager? = null

    override fun onBind(p0: Intent?): IBinder? = null

    override fun onCreate() {
        super.onCreate()
        notificationManager = getSystemService(NotificationManager::class.java)
        notificationChannel()
    }

    override fun onStartCommand(intent: Intent?, flags: Int, startId: Int): Int {
        when (intent?.action) {
            TimerActions.START.toString() -> {
                val duration = intent.getIntExtra(EXTRA_DURATION, 10) // Default 10 minutes
                Log.d("INTENT", "onStartCommand: $duration")
                startTimer(duration)
            }
            TimerActions.STOP.toString() -> {
                stopSelf()
            }
        }
        return START_STICKY
    }

    private fun startTimer(duration: Int) {
        timer(duration)
        startForeground(NOTIFICATION_ID, timerNotification(remainingTime))
    }

    private fun timerNotification(remainingTime: Int): Notification {
        return NotificationCompat.Builder(this, CHANNEL_ID)
            .setSmallIcon(R.drawable.ic_launcher_foreground)
            .setContentTitle("Timer")
            .setContentText("Time Left \${formater(remainingTime)}")
            .setPriority(NotificationCompat.PRIORITY_HIGH)
            .setCategory(NotificationCompat.CATEGORY_SERVICE)
            .build()
    }

    private fun timer(duration: Int) {
        remainingTime = duration • 60 // Convert minutes to seconds

        job = CoroutineScope(Dispatchers.Main).launch {
            while (remainingTime > 0) {
                delay(1000)
                remainingTime--
                updateTimerNotification(remainingTime)
            }
            stopSelf()
        }
    }

    private fun notificationChannel() {
        if (Build.VERSION.SDK_INT >= Build.VERSION_CODES.O) {
            val channel = NotificationChannel(
                CHANNEL_ID,
                "Timer Service",
                NotificationManager.IMPORTANCE_LOW
            )
            notificationManager?.createNotificationChannel(channel)
        }
    }

    private fun updateTimerNotification(remainingTime: Int) {
        notificationManager?.notify(NOTIFICATION_ID, timerNotification(remainingTime))
    }

    private fun formater(seconds: Int): String {
        val minutes = seconds / 60
        val sec = seconds % 60
        return String.format("%02d:%02d", minutes, sec)
    }

    override fun onDestroy() {
        super.onDestroy()
        job?.cancel()
    }

    enum class TimerActions {
        START, STOP
    }
}`
				},
				{
					Title: "Creating a Button to Start the Timer Service",
					Text: "Now, let's add a button in MainActivity to start the TimerService.",
					Sample: `class MainActivity : ComponentActivity() {
    override fun onCreate(savedInstanceState: Bundle?) {
        super.onCreate(savedInstanceState)
        enableEdgeToEdge()
        setContent {
            TimerServiceTheme {
                Scaffold(modifier = Modifier.fillMaxSize()) { innerPadding ->
                    Column(
                        modifier = Modifier
                            .fillMaxSize()
                            .padding(innerPadding),
                        verticalArrangement = Arrangement.Center,
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        val context = LocalContext.current
                        Button(onClick = {
                            val timerService = Intent(context, TimerService::class.java).apply {
                                action = TimerService.TimerActions.START.toString()
                                putExtra(TimerService.EXTRA_DURATION, 15) // Change timer duration here
                            }
                            ContextCompat.startForegroundService(context, timerService)
                        }) {
                            Text(text = "Start Timer")
                        }
                    }
                }
            }
        }
    }
}`
				},
				{ Text: "• LocalContext.current: This retrieves the context from Jetpack Compose, which is required to start the service." },
				{ Text: "• Intent(context, TimerService::class.java): Creates an intent to start the TimerService." },
				{ Text: "• putExtra(TimerService.EXTRA_DURATION, 15): Passes the timer duration (15 minutes in this case)." },
				{
					Text: "• ContextCompat.startForegroundService(context, timerService): Starts the service in foreground" +
						" mode, ensuring it runs persistently and displays a notification."
				},
				{
					Title: "Conclusion",
					Text: "By implementing foreground services, we ensure that long-running operations, like a countdown timer," +
						" continue even when the app is in the background. Using notifications, users remain aware of ongoing tasks." +
						" This approach is useful for fitness timers, focus apps, or countdown alarms. "
				}
			]
		},
		{
			ID: 13,
			Title:
				"Getting Started with Jetpack Compose: Building Modern Native Android UIs",
			Author: "Reynaldo Mejia",
			Image: KT,
			SocialLink: reynaldoSocialNetwork[0].Link,
			SocialNetwork: reynaldoSocialNetwork,
			Content: [
				{
					Title: "Introduction",
					Text: "In this article, we’ll explore the basics of building native applications using Jetpack Compose, Google’s modern UI toolkit.",
				},
				{
					Title: "Jetpack Compose",
					Text: "Jetpack Compose is an UI toolkit based on Kotlin, developed by Google. It is the recommended approach for building user interfaces  applications. Jetpack Compose accelerates the development process for native applications, offering flexibility and efficiency. Moreover, it enables the creation of applications for a wide range of devices, including phones, tablets, foldables, and Wear OS devices.",
					Sample: `
	@Composable
	fun FunCoding() {

   	 	var text by remember { mutableStateOf("Android") }

   		 Column {
    	   		 Button(onClick = { text = "Android Developer" }) {
            			Text(text = "Change Text")
			 }
    			Text(text = text)
  	 	 }
	
	}`,
				},
				{
					Title: "Composable",
					Text: "A composable is a function that contains elements used to create your UI interface. To build a composable component, you must use the @Composable annotation. This annotation is essential because it informs the Compose compiler that the annotated function should be transformed into a UI element.",
					Sample: `
	@Composable
	fun HelloHuman() {
		Text(text = “Hello, Human! I am Bot”)
	}
		`,
				},
				{
					Text: "In the example above, the composable function does not return anything. Composable functions are solely responsible for emitting UI elements. To manage the logic of the interface, a composable function allows you to pass parameters as shown below.",
				},
				{
					Sample: `
				
 	@Composable
	fun GreetingWithParameter(name: String) {
		Text(text = "Hello, $name! I am Bot")
	}

	@Composable
	fun App(){
		Column{
			GreetingWithParameter(“Monica”)
			GreetingWithParameter(“Alice”)
			GreetingWithParameter(“Bob”)
			GreetingWithParameter(“Reynaldo”)
		}
	}
				`,
				},
				{
					Title: "Recomposition",
					Text: "Recomposition refers to the process of redrawing the UI when the state of a composable function changes. For example, consider a composable counter. Each time the button is clicked, the counter’s state changes, prompting the composable to update and display the new value.",
					Sample: `
	@Composable
	fun App(){

		var name by remember { mutableStateOf(0) }

		Button(onClick = { counter++}) {
			Text(“Click”)
		}

		Text("I've been clicked $clicks times")
	}
				`,
				},
				{
					Title: "Basic Layout",
					Text: "As previously mentioned, a composable function does not return a value. In other words, it is a function of type void or Unit. While composable functions can emit multiple UI elements, it is crucial to structure these elements properly to achieve the desired visual layout.",
					Sample: `
	@Composable
	fun Greeting(name: String) {
		Text(“Hello, $name”)
		Text(“Hello, World”)
	}
				`,
				},
				{
					Text: "The provided example illustrates a common issue when rearranging text elements within the Greeting component. To address this and ensure a visually appealing layout, we can utilize layout components like Column, Row, and Box. These components offer the flexibility to arrange elements effectively.",
				},
				{ Title: "Layout Components" },
				{
					Title: "Column",
					Text: "Column arranges all child elements vertically within the column.",
					Sample: `
	@Composable
	fun Greeting(name: String) {
		Column{
			Text(“Hello, $name”)
			Text(“Hello, World”)
		}
	}
				`,
				},
				{
					Title: "Row",
					Text: "Aligns child elements horizontally, placing them side by side.",
					Sample: `
	@Composable
	fun Greeting(name: String) {
		Row{
			Text(“Hello, $name”)
			Text(“Hello, World”)
		}
	}
				`,
				},
				{
					Title: "Box",
					Text: "Box allows you to overlay one element on top of another. A chat avatar, for instance, might use a Box to place a status indicator on top of the user's profile picture.",
					Sample: `
	@Composable
	fun BinaryStackAvatar() {
		Box{
			Image( painter = painterResource(id = R.drawable.super_user),
			Icon(Icons.Filled.circle_filled, contentDescription = null)
		}
	}
				`,
				},
				{
					Title: "Conclusion",
					Text: "In this article, we explored the basics of Jetpack Compose, including the concept of composable functions, the process of recomposition, and the use of layout components such as Column, Row, and Box. These foundational elements enable developers to create dynamic, responsive, and well-structured user interfaces efficiently. Jetpack Compose offers a declarative and intuitive approach to building UIs. Powered by Kotlin, it simplifies the UI design process.",
				},
			],
		},
		{
			ID: 14,
			Author: "Reynaldo Mejia",
			Image: KT,
			SocialLink: reynaldoSocialNetwork[0].Link,
			Title:
				"CameraX Tutorial: Implementing Camera Functionality in Android Apps",
			SourceCodeLink: "https://github.com/redmejia/x-camera",
			SourceCodeLinkName: "XCamera",
			SocialNetwork: reynaldoSocialNetwork,
			Content: [
				{
					Title: "Introduction",
					Text:
						"In this article, we will learn how to implement CameraX, a powerful library that simplifies interaction with the device's camera in Android applications." +
						" CameraX provides a modern and developer-friendly API for integrating camera functionalities, making it easier to add features like image analysis, image capture, and video recording.",
				},
				{
					Title: "What is CameraX?",
					Text:
						"CameraX is a library developed by Google that allows you to work seamlessly with the device's camera and integrate it into your application. " +
						"It simplifies the development process while providing powerful capabilities for image and video capture, as well as image analysis.",
				},
				{
					Text: "CameraX supports devices running Android 5.0 (API level 21) and above, ensuring compatibility across a wide range of devices.",
				},
				{
					Title: "Adding Dependencies",
					Text: "To start using CameraX, add the following implementations in your dependencies module's build.gradle file:",
					Sample: `\ndependencies {

    val camerax_version = "1.5.0-alpha03"

    implementation("androidx.camera:camera-camera2:$camerax_version")

    implementation("androidx.camera:camera-lifecycle:$camerax_version")

    implementation("androidx.camera:camera-view:$camerax_version")

  }\n\n`,
				},
				{
					Title: "Configuring Permissions",
					Text: "Permissions are required to protect user privacy, such as accessing the camera or recording video. Add the following code to your app's AndroidManifest.xml:",
					Sample: `\n<uses-feature
            android:name="android.hardware.camera"
            android:required="false" />
<uses-permission android:name="android.permission.CAMERA" />
        `,
				},
				{
					Title: "Handling Permission Flow in MainActivity",
					Text:
						"Now, we need to handle the camera permission flow in your MainActivity file." +
						" To do this, we need to register a permission request every time the app initializes.",
					Sample: `\nvar isCameraPermissionGranted by remember { mutableStateOf(false) }
var isCameraPermissionDenied by remember { mutableStateOf(false) }

val permissionResultLauncher = rememberLauncherForActivityResult(
    contract = ActivityResultContracts.RequestPermission(),
    onResult = { isGranted ->
        isCameraPermissionGranted = isGranted
        isCameraPermissionDenied = !isGranted
    }
)

LaunchedEffect(Unit) {
    when {
        ContextCompat.checkSelfPermission(
            applicationContext,
            Manifest.permission.CAMERA
        ) == PackageManager.PERMISSION_GRANTED -> {
            isCameraPermissionGranted = true
        }
        else -> {
            permissionResultLauncher.launch(Manifest.permission.CAMERA)
        }
    }
}\n\n`,
				},
				{
					Text: "isCameraPermissionGranted: Tracks whether the camera permission has been granted.",
				},
				{
					Text: "isCameraPermissionDenied: Tracks whether the user has denied the permission.",
				},
				{
					Text: "rememberLauncherForActivityResult: Launches the permission request and handles the result.",
				},
				{
					Text: "LaunchedEffect: Ensures the permission flow is executed when the composable is first rendered.",
				},
				{
					Title: "Setting Up Camera Preview",
					Text: "Create a composable function named XCameraPreview to set up and display the camera preview.",
					Sample: `\n\n@Composable
fun XCameraPreview() {
    val context = LocalContext.current
    val lifecycleOwner = LocalLifecycleOwner.current

    val cameraController = remember {
        LifecycleCameraController(context).apply {
            setEnabledUseCases(CameraController.IMAGE_CAPTURE)
            bindToLifecycle(lifecycleOwner)
        }
    }

    Box(modifier = Modifier.fillMaxSize()) {
        AndroidView(
            modifier = Modifier.fillMaxSize(),
            factory = { ctx ->
                PreviewView(ctx).apply {
                    scaleType = PreviewView.ScaleType.FILL_CENTER
                    implementationMode = PreviewView.ImplementationMode.COMPATIBLE
                    controller = cameraController
                }
            },
            onRelease = {
                cameraController.unbind()
            }
        )
    }
}\n\n`,
				},
				{
					Text:
						"LocalContext: LocalContext.current offers a way to obtain the current context," +
						" functioning as if you were inside an Activity or Fragment when using Composables.",
				},
				{
					Text:
						"LocalLifecycleOwner: lifecycleOwner is responsible for observing the lifecycle of " +
						"the Composable and reacting to lifecycle-related events.",
				},
				{
					Text: "LifecycleCameraController: Manages the camera lifecycle, such as initialization and release.",
				},
				{ Text: "Box: Ensures the camera preview occupies the entire screen." },
				{
					Text: "AndroidView: Integrates the PreviewView from the Android View system into a Jetpack Compose UI.",
				},
				{
					Text: "PreviewView: A specialized view to render the camera's preview.",
				},
				{
					Title: "Conclusion",
					Text:
						"CameraX is a powerful tool for modern Android development, offering a straightforward and efficient " +
						"way to integrate camera functionalities into your app. With its support for advanced use cases and Jetpack Compose compatibility.",
				},
			],
		},
		{
			ID: 15,
			Author: "Reynaldo Mejia",
			Image: KT,
			SocialLink: reynaldoSocialNetwork[0].Link,
			Title: "Android Widgets with Jetpack Glance",
			SourceCodeLink: "https://github.com/redmejia/counters",
			Resource: [
				{ ResourceLinkName: "Jetpack Glance", ResourceLink: "https://developer.android.com/develop/ui/compose/glance" },
				{ ResourceLinkName: "Glance setup", ResourceLink: "https://developer.android.com/develop/ui/compose/glance/setup" },
				{ ResourceLinkName: "Build UI with Glance", ResourceLink: "https://developer.android.com/develop/ui/compose/glance/build-ui" },
				{ ResourceLinkName: "Manage and update Glance App", ResourceLink: "https://developer.android.com/develop/ui/compose/glance/glance-app-widget" },
				{ ResourceLinkName: "Handle user interaction", ResourceLink: "https://developer.android.com/develop/ui/compose/glance/user-interaction" },
			],
			SourceCodeLinkName: "Counters Widgets",
			SocialNetwork: reynaldoSocialNetwork,
			Content: [
				{
					Title: "Widgets in Android",
					Text: "Widgets are small screens or views that can be embedded into other apps—for example," +
						" the Home Screen of your device. They provide quick, glanceable information and allow" +
						" limited interaction without needing to open an app."
				},
				{ Text: "Some common examples of widgets include:" },
				{ Text: "• Calendar: Display upcoming events." },
				{ Text: "• Weather: Show current weather conditions and forecasts." },
				{ Text: "• Battery: Display battery percentage." },
				{ Text: "• Music: Control music playback." },
				{ Text: "• News: Provide news headlines." },
				{
					Title: "Building a Widget with Glance",
					Text: "To create a widget using Jetpack Glance, you use layout components like Column," +
						" Row, and Box, just as you would in Jetpack Compose. The key difference" +
						" is that you use GlanceModifier instead of Modifier to style your elements."
				},
				{
					Title: "Creating a Counter Widget",
					Text: "In this tutorial, we’ll create a simple counter widget that" +
						" demonstrates the basic setup, UI composition, state management, and user interaction using Glance."
				},
				{
					Title: "Widget Setup",
					Text: "Add the Glance dependencies in your build.gradle.kts (Module-level):",
					Sample: `dependencies {
    // Glance Widget (AppWidget support)
    implementation("androidx.glance:glance-appwidget:1.1.1")

    // Material 3 interop APIs
    implementation("androidx.glance:glance-material3:1.1.1")
}
`
				},
				{
					Text: "Enable Compose and set the compiler extension version:",
					Sample: `android {
    ...
    buildFeatures {
        compose = true
    }

    composeOptions {
        kotlinCompilerExtensionVersion = "1.5.15"
    }
}`
				},
				{
					Text: "Although the Glance documentation recommends Java 8 (1.8), Java 11 works without issues:",
					Sample: `kotlinOptions {
    jvmTarget = "11"
}`
				},
				{
					Title: "Creating an App Widget Receiver",
					Text: "Create a widget receiver class that extends GlanceAppWidgetReceiver.",
					Sample: `import androidx.glance.appwidget.GlanceAppWidget
import androidx.glance.appwidget.GlanceAppWidgetReceiver

class CounterWidgetReceiver : GlanceAppWidgetReceiver() {
    override val glanceAppWidget: GlanceAppWidget = CounterWidget()
}`
				},
				{
					Title: "Register the Widget Receiver in the Manifest",
					Text: "Update your AndroidManifest.xml to register the widget:",
					Sample: `<manifest xmlns:android="http://schemas.android.com/apk/res/android"
    xmlns:tools="http://schemas.android.com/tools">
<application
    ... attributes ... >
	<uses-permission android:name="android.permission.POST_NOTIFICATIONS" />	
	<uses-permission android:name="android.permission.FOREGROUND_SERVICE" />
    <activity
        ... attributes ...>
        <intent-filter>
            <action android:name="android.intent.action.MAIN" />
            <category android:name="android.intent.category.LAUNCHER" />
        </intent-filter>
    </activity>

<receiver
    android:name=".presentation.widgets.counter.CounterWidgetReceiver"
    android:exported="true"
    android:label="@string/widget_label">
    <intent-filter>
        <action android:name="android.appwidget.action.APPWIDGET_UPDATE" />
    </intent-filter>
    <meta-data
        android:name="android.appwidget.provider"
        android:resource="@xml/counter_widget" />
</receiver>
<!--For android:label="" create label string in the res/values/strings.xml -->
<!-- In the meta-data android:resource="" add the counter_widget xml
resource from res/xml/counter_widget.xml-->

</application>
</manifest>`
				},
				{
					Text: "Next, in your res/xml directory, create a new XML file with the" +
						" name of your widget (e.g., counter_widget.xml). Open the file and add the following:",
					Sample: `<?xml version="1.0" encoding="utf-8"?>
<appwidget-provider xmlns:android="http://schemas.android.com/apk/res/android"
    android:minWidth="240dp"
    android:minHeight="60dp"
    android:updatePeriodMillis="0"
    android:resizeMode="vertical|horizontal"
    android:description="@string/widget_counter"
    android:initialLayout="@layout/glance_default_loading_layout"
    />
<!-- For widget android:description="" create new string in the res/values/strings.xml-->`
				},
				{ Text: "• minWidth and minHeight: Define initial size." },
				{ Text: "• resizeMode: Allow vertical, horizontal, or both resizing (vertical|horizontal)." },
				{ Text: "• description: Describe your widget; defined in strings.xml." },
				{ Text: "• initialLayout: You can use Glance’s default or a custom loading layout." },
				{
					Title: "Define Your Counter Widget",
					Text: "Create the CounterWidget class that extends GlanceAppWidget. Here’s the full code:",
					Sample: `val COUNT_KEY = intPreferencesKey("count")
class CounterWidget : GlanceAppWidget() {
    override suspend fun provideGlance(context: Context, id: GlanceId) {
        provideContent {
            val prefs = currentState<Preferences>()
            val count = prefs[COUNT_KEY] ?: 0
            Counter(count)
        }
    }

    @Composable
    private fun Counter(count: Int) {
        Column(
            modifier = GlanceModifier
                .appWidgetBackground()
                .background(Color.White)
                .fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Row(
                modifier = GlanceModifier.fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Button(
                    text = "+",
                    onClick = actionRunCallback<Increment>(),
                    colors = ButtonDefaults.buttonColors(
                        backgroundColor = GlanceTheme.colors.background,
                        contentColor = GlanceTheme.colors.primary
                    ),
                    style = TextStyle(fontSize = 24.sp, fontWeight = FontWeight.Bold)
                )

                Text(
                    "$count",
                    modifier = GlanceModifier.padding(horizontal = 30.dp),
                    style = TextStyle(fontSize = 18.sp, fontWeight = FontWeight.Bold)
                )

                Button(
                    text = "-",
                    onClick = actionRunCallback<Decrement>(),
                    colors = ButtonDefaults.buttonColors(
                        backgroundColor = GlanceTheme.colors.background,
                        contentColor = GlanceTheme.colors.primary
                    ),
                    style = TextStyle(fontSize = 24.sp, fontWeight = FontWeight.Bold)
                )
            }
        }
    }
}`
				},
				{
					Text: "The layout is built using Column and Row, similar to Jetpack Compose." +
						" It includes two buttons and a Text displaying the count. The buttons" +
						" trigger actions to increment or decrement the count."
				},
				{
					Title: "Handling User Interactions",
					Text: "To respond to user interactions:"
				},
				{
					Text: "1. Define a key for storing state:",
					Sample: `val COUNT_KEY = intPreferencesKey("count")`
				},
				{
					Text: "2. Use currentState<Preferences>() to read current state:",
					Sample: `val prefs = currentState<Preferences>()`
				},
				{
					Text: "3. Implement the actions:",
					Sample: `class Increment : ActionCallback {
    override suspend fun onAction(
        context: Context,
        glanceId: GlanceId,
        parameters: ActionParameters,
    ) {
        updateAppWidgetState(context, glanceId) { prefs ->
            val currentCount = prefs[COUNT_KEY] ?: 0
            prefs[COUNT_KEY] = currentCount + 1
        }
        CounterWidget().update(context, glanceId)
    }
}

class Decrement : ActionCallback {
    override suspend fun onAction(
        context: Context,
        glanceId: GlanceId,
        parameters: ActionParameters,
    ) {
        updateAppWidgetState(context, glanceId) { prefs ->
            val currentCount = prefs[COUNT_KEY] ?: 0
            prefs[COUNT_KEY] = (currentCount - 1).coerceAtLeast(0)
        }
        CounterWidget().update(context, glanceId)
    }
}`
				},
				{ Text: "• updateAppWidgetState is used to modify the widget’s local state." },
				{ Text: "• CounterWidget().update() refreshes the UI after state changes." },
				{
					Title: "Conclusion",
					Text: "In this tutorial, we built a simple counter widget using Jetpack Glance. This covered:"
				},
				{ Text: "• Setting up Glance in your project." },
				{ Text: "• Registering a widget." },
				{ Text: "• Creating a custom layout using familiar Compose-like structures (Column, Row, Text, Button)." },
				{ Text: "• Managing widget state using Preferences." },
				{ Text: "• Handling user interactions via ActionCallback." },
				{
					Text: "Though basic, this example lays the groundwork for more advanced widgets." +
						" Jetpack Glance provides a modern, declarative approach to widget development" +
						" and seamlessly integrates with existing Compose knowledge."
				}
			]
		}
	],
};
